import { render, staticRenderFns } from "./GTransferenciaTurma.vue?vue&type=template&id=254d8b45&scoped=true"
import script from "./GTransferenciaTurma.vue?vue&type=script&lang=js"
export * from "./GTransferenciaTurma.vue?vue&type=script&lang=js"
import style0 from "./GTransferenciaTurma.vue?vue&type=style&index=0&id=254d8b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d8b45",
  null
  
)

export default component.exports